<app-dialog
  [headerLabel]="headerLabel"
  [primaryActionText]="'ACTION.GOT_IT' | translate"
  [secondaryActionText]="
    'SETTINGS.CLIENT_COMMUNICATION.PAYMENT_REMINDERS.SEND_PREVIEW' | translate
  "
  [dialogType]="dialogType"
  (onSecondaryAction)="sendRemindersPreview()"
>
  <div id="view-reminders-dialog">
    <p>
      {{ 'DIALOG.REMINDERS.REMINDERS_WILL_BE_SENT_INFO' | translate }}
    </p>

    <ul *ngIf="schedule" class="schedule-list">
      <li *ngIf="schedule.includes(-3)" class="schedule-item">
        {{
          'SETTINGS.CLIENT_COMMUNICATION.PAYMENT_REMINDERS.OPTION_3_BEFORE'
            | translate
        }}
      </li>

      <li *ngIf="schedule.includes(0)" class="schedule-item">
        {{
          'SETTINGS.CLIENT_COMMUNICATION.PAYMENT_REMINDERS.OPTION_ON_DUE'
            | translate
        }}
      </li>

      <li *ngIf="schedule.includes(3)" class="schedule-item">
        {{
          'SETTINGS.CLIENT_COMMUNICATION.PAYMENT_REMINDERS.OPTION_3_AFTER'
            | translate
        }}
      </li>

      <li *ngIf="schedule.includes(7)" class="schedule-item">
        {{
          'SETTINGS.CLIENT_COMMUNICATION.PAYMENT_REMINDERS.OPTION_7_AFTER'
            | translate
        }}
      </li>
    </ul>

    <p>
      {{ 'DIALOG.REMINDERS.GO_TO_SETTINGS' | translate }}
    </p>
  </div>
</app-dialog>
